/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeliveryRangeModel { 
    id: number;
    createDate: string;
    modifyDate: string;
    enabled: boolean;
    removed: boolean;
    storeId: number;
    fromTime: string;
    toTime: string;
    date: string;
    limit: number;
    reserved?: number;
}

